import { Helmet } from "react-helmet-async";

/** Marks a route as noindex,nofollow for search engines. */
const Noindex = () => (
  <Helmet>
    <meta name="robots" content="noindex,nofollow" />
  </Helmet>
);

export default Noindex;